/**
 * Project Selector Component
 *
 * Dropdown for selecting between available projects
 * Triggers data refresh when project changes
 *
 * Design specs from Figma (node 3548-7967):
 * - Radio icon: 18x18px before project name
 * - Gap between icon and text: 6px
 * - Height: 50px
 * - Border: #7846FF
 * - Background: #15203C
 * - Text: #F6F6F6, 16px normal
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,

} from "@/components/ui/select";
import { Circle } from "lucide-react";
import { ProjectOption } from "@/types/orcamentos.interface";

interface ProjectSelectorProps {
  /** Available projects for selection */
  projects: ProjectOption[];
  /** Currently selected project */
  selectedProject: ProjectOption;
  /** Callback when project changes */
  onProjectChange: (projectId: string) => void;
}

export function ProjectSelector({
  projects,
  selectedProject,
  onProjectChange,
}: ProjectSelectorProps) {
  return (
    <div className="w-[300px]">
      <Select value={selectedProject.id} onValueChange={onProjectChange}>
        <SelectTrigger className="bg-transparent border border-[#7846FF] text-[#F6F6F6] h-10 rounded-lg px-4 py-2 hover:bg-[#15203C]/50 transition-colors">
          <div className="flex items-center gap-2">
            <span className="text-[#7846FF] fill-[#7846FF] text-xs">●</span>
            <span className="font-medium text-sm text-[#F6F6F6] truncate">
              {selectedProject.name}
            </span>
          </div>
        </SelectTrigger>
        <SelectContent className="bg-[#15203C] border-[#7846FF]">
          {projects.map((project) => (
            <SelectItem
              key={project.id}
              value={project.id}
              className="text-[#F6F6F6] cursor-pointer"
            >
              <div className="flex items-center gap-2">
                <span className="text-[#7846FF] fill-[#7846FF] text-xs">●</span>
                <span className="truncate">{project.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
